import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-follow-up',
  templateUrl: './follow-up.component.html',
  styleUrls: ['./follow-up.component.scss']
})
export class FollowUpComponent implements OnInit {
  apptId: any;

  constructor(private spinner:NgxSpinnerService,private http:HttpClient,private appointmentService:AppointmentService,
    private authenticationService:AuthenticationService, private authService:AuthenticationService,private router:Router) { }

  value:String="Upcoming";
  appointments:any=[]
  userRole:any
  status!:string
  tests:any
  surveys:any
  selectedTests:any
  selectedSurveys:any
  show:boolean=false
  followUpDetails:any=[]

  ngOnInit(): void {
    this.show=false
    let location=null;

    let diagId= null;
    let status="FOLLOWUP";
    this.spinner.show()
    this.userRole = this.authService.getUserType()
    if( this.userRole!='ADMIN' && this.userRole!='DIRECTOR'){
      diagId= this.authenticationService.getUserId();
    }
    this.appointmentService.getAppointments(location,diagId,status,null, null, null).subscribe((res: any)=>{
      this.appointments=res.data;
      this.appointments.forEach((el:any) => {
        let schedules=el.appointmentDetails.schedules
        if(schedules[schedules.length-1].status=="FOLLOWUP"){
          this.followUpDetails.push(schedules[schedules.length-1])
        }
      });

      this.show=true

      this.spinner.hide()

     
    })
  }
  getAppointments(){

  }
  selectValue(value:string){
    this.value=value;


  }
  setApptId(apptId:any){
    this.apptId=apptId
    
  }
  submitPayment(){
    
  }

  
  
  

}